import type { ConfigImportType } from '../ab-test-global-provider';
import LucidCoLogin from './lucid-co-login';

/** Global configuration for all Co-specific experiments
 * 
 * @remarks
 * - Imports and exports the configuration hooks for A/B tests on Lucid.co, where product="co".
 * - Each import is an implementation of the useAbTestInit hook, which initializes the A/B test
 * - All configs in this file will automatically be included in the global A/B testing provider
 * 
 * @example
 * ```tsx
 * [index.ts]
 import MockTest from './mock-import' // see imported file example below

 const coConfig = [MockTest] as ConfigImportType[];

 export default coConfig;
 * 
  // imported file example
 * [./mock-import.ts]
 import useAbTestInit from '../../hooks/use-ab-test-init';
 import type { ABTestConfigProps } from '../ab-test-global-provider';
 
 const MockTest = ({ shortCode, pageType, nid }: ABTestConfigProps) =>
   useAbTestInit({
     isAboveTheFold: true,
     branchesToRender: ['T_A', 'T_B'],
     testName: 'MockTestName',
     willTriggerFire: shortCode === 'en' && pageType === 'contact-form' && nid === '2',
   });
 
 export default MockTest;
 * ```
 */
export const coConfig = [LucidCoLogin] as ConfigImportType[];

export default coConfig;
